module.exports = __webpack_public_path__ + "static/img/data_line.8d6a48e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/statistic/data_line.png
// module id = IDhZ
// module chunks = 2